@if (showHeader) {
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{title}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()"></button>
  </div>
}
<div class="modal-body">
  <ng-content></ng-content>
</div>
@if (showFooter) {
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Close</button>
    @if (showSave) {
      <button type="button" class="btn btn-site-secondary" (click)="save()">Save changes</button>
    }
  </div>
}
